import React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface TriangleMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    name: string;
    opacity: number;
    showTooltip: boolean;
    isAnimated: boolean;
    onClick?: (event: any) => void;
}

export const TriangleMarker = (props: TriangleMarkerProps) => {
    const latFactor = 1 / 180000;
    const size = props.radius * latFactor;

    const getEquilateralTriangleVertices = (center: any, radius: number) => {
        const [cx, cy] = center;
        const diameter = 2 * radius;

        const topVertex = [cx + 1.5 * radius, cy];
        const bottomLeft = [cx - radius, cy - diameter];
        const bottomRight = [cx - radius, cy + diameter];

        return [topVertex, bottomLeft, bottomRight];
    };

    const points = getEquilateralTriangleVertices(props.position, size);
    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };
    return (
        <Polygon
            pane="markerPane"
            eventHandlers={{
                click: handleClick,
            }}
            key={`${props.key}-${props.opacity}`}
            positions={points}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Polygon>
    );
};
